module.exports = __webpack_public_path__ + "img/aboutProduct.fb13a80b.svg";